import mongoose from 'mongoose';
import source, { ISourceDocument } from '../schemas/source';

export default (mongoose.models.Source ||
  mongoose.model<ISourceDocument>('Source', source)) as mongoose.Model<ISourceDocument>;
